import React from 'react'
import { connect } from 'react-redux'
import PaymentList from './PaymentList'
import { fnum } from '../../utils/utils'
import { updateBalance } from '../../actions/orderActions'
import { fetchPayments, editPost } from '../../actions/postActions'

class PaymentForm extends React.Component {

  componentWillMount(){
    this.props.fetchPayments();
    window.scrollTo(0, 0);
  }

  updateBalance = (orderId, difS, difB1, difB2) => {
    if(parseInt(difS,10) !==0 || parseInt(difB1,10) !==0 || parseInt(difB2,10) !==0){
      this.props.updateBalance(orderId, difS, difB1, difB2);
    }
  }

  render() {
    const { posts, comps, srvcs, editPost } = this.props;
    const { search, sort, filter } = this.props.orders;
    const orders = this.props.orders.data;
    const fltrOrders = orders.filter(el =>{
      var found = true;
      var filtered = false;
      for (var i = 0; i < filter.length; i++){
        if(el.order_stts_id === filter[i]){
          filtered = true;
          break;
        }
      }
      if(search){
        const searchValue = el.order_desc.toString()
          +el.order_num+comps[el.order_comp_id].comp_desc.toString();
        found= searchValue.toLowerCase().indexOf(search) !== -1;
      }
      return filtered && found;
    });

    const sortField = sort.field;
    const sortAsc = sort.asc
    const sortedOrders = fltrOrders.sort( (a, b) => {
      if(sort.field === 'comp_desc' && comps.hasOwnProperty(a.order_comp_id)
        && comps.hasOwnProperty(b.order_comp_id)){
        if(comps[a.order_comp_id].comp_desc < comps[b.order_comp_id].comp_desc)
          return sort.asc ? -1 : 1
        if(comps[a.order_comp_id].comp_desc > comps[b.order_comp_id].comp_desc)
          return sort.asc ? 1 : -1
      }
      if(a[sortField] < b[sortField])
         return sortAsc ? -1 : 1
      if(a[sortField] > b[sortField])
         return sortAsc ? 1 : -1
      if(a.order_id < b.order_id)
         return sortAsc ? -1 : 1
      if(a.order_id > b.order_id)
         return sortAsc ? 1 : -1
      return 0
    });
    var output=[];
    for(var i = 0; i < sortedOrders.length; i++){
      const order = sortedOrders[i];
      if(
        posts.hasOwnProperty(order.order_id) &&
        (order.p1_balance !== 0 || order.p2_balance !== 0)
      ){
        const fltrD = posts[order.order_id].filter(el => {
          if(el.post_active === 1){
            return true;
          }
          return false;
        });
        var pmntG = {
          [order.order_comp1_id]:[]
        };
        var sellerG = {
          [order.order_comp1_id]:{
            goods:0,
            money:0
          }
        };
        for (var j = 0; j < fltrD.length; j++){
          if (!sellerG.hasOwnProperty(fltrD[j].cost_seller)){
            sellerG[fltrD[j].cost_seller] = {goods:0,money:0};
          }
          if (!sellerG.hasOwnProperty(fltrD[j].post_seller)){
            sellerG[fltrD[j].post_seller] = {goods:0,money:0};
          }
          if(srvcs[fltrD[j].post_srvc_id].srvc_type === -1){
            sellerG[fltrD[j].post_seller].money += fltrD[j].post_price*fltrD[j].post_qntt;
            if (!pmntG.hasOwnProperty(fltrD[j].post_seller)){
              pmntG[fltrD[j].post_seller] = [];
            }
            pmntG[fltrD[j].post_seller].push(fltrD[j]);
          }
          else{
            sellerG[order.order_comp1_id].goods += fltrD[j].post_price*fltrD[j].post_qntt;
            sellerG[fltrD[j].cost_seller].goods += fltrD[j].cost_price*fltrD[j].cost_qntt;
          }
        }
        const myDebt = sellerG[order.order_comp1_id].goods - sellerG[order.order_comp1_id].money;
        const myStyle = myDebt !== 0 ? 'h4 bg-danger text-danger' : '';

        var sellerDebt = [];
        for (var key in sellerG){
          if(
            sellerG.hasOwnProperty(key)
            && key>0
            && parseInt(key,10)!==order.order_comp1_id
            && (sellerG[key].money !== 0 || sellerG[key].goods !== 0)
          ){
            const debt = sellerG[key].goods - sellerG[key].money;
            const style = debt !== 0 ? 'h4 bg-danger text-danger' : '';
            sellerDebt.push(
              <p key={i+"."+key+".1"}>
                <strong><u>{comps[key].comp_desc}</u></strong>: {' '}
                всего {' '}
                {fnum(sellerG[key].money+debt)},
                в оплатах {' '}
                {fnum(sellerG[key].money)},
                остаток {' '}
                <span className={style}>{fnum(debt)}</span>
              </p>
            );
            const pmnts = pmntG.hasOwnProperty(key) ? pmntG[key] : [];
            sellerDebt.push(
              <PaymentList
                key={i+"."+key+".2"}
                seller={key}
                payer={order.order_comp1_id}
                pmnts={pmnts}
                editPost={editPost}
                srvcs={srvcs}
                order={order}
                debt={debt}
                updtBlnc={this.updateBalance}
                blnc={2}
              />
              );
          }
        }
        output.push(
          <div key={"order" + i}>
            <h3 className="bg-info">Заказ {order.order_num}</h3>
            <p>
              <strong>Заказчик <u>{comps[order.order_comp_id].comp_desc}</u></strong>: {' '}
              Всего {' '}
              {fnum(sellerG[order.order_comp1_id].money+myDebt)},
              в оплатах {' '}
              {fnum(sellerG[order.order_comp1_id].money)},
              остаток {' '}
              <span className={myStyle}>{fnum(myDebt)}</span>
            </p>
            <PaymentList
              seller={order.order_comp1_id}
              payer={order.order_comp_id}
              pmnts={pmntG[order.order_comp1_id]}
              srvcs={srvcs}
              editPost={editPost}
              order={order}
              debt={myDebt}
              updtBlnc={this.updateBalance}
              blnc={1}
            />
            {sellerDebt}
          </div>
        );
      }

    }

    return (
      <div>
        {output}
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    orders: store.orders,
    posts: store.posts,
    comps: store.comps.data,
    srvcs: store.srvcs.data
  }
}

export default connect(mapOrdersToProps, {
  fetchPayments,
  updateBalance,
  editPost
})(PaymentForm);



// WEBPACK FOOTER //
// ./src/components/payment/PaymentForm.js